__turbopack_context__.v({
  "call": "style-module-scss-module__EJHnXW__call",
  "content": "style-module-scss-module__EJHnXW__content",
  "cta": "style-module-scss-module__EJHnXW__cta",
  "subtitle": "style-module-scss-module__EJHnXW__subtitle",
  "title": "style-module-scss-module__EJHnXW__title",
  "videoBackground": "style-module-scss-module__EJHnXW__videoBackground",
  "videoWrapper": "style-module-scss-module__EJHnXW__videoWrapper",
  "wrapper": "style-module-scss-module__EJHnXW__wrapper",
});
